module.exports = __webpack_public_path__ + "4f589f4867dbd57estep_4.05fb670b.png";